import { FileTextIcon, FolderOpenIcon } from "lucide-react";

const EMPTY_STATE_CARD_CLASS =
  "max-w-xl rounded-3xl border border-gray-200/80 bg-white px-6 py-8 text-center shadow-sm shadow-gray-950/5";

export const SkillCollectionViewerEmptyNoFiles = () => (
  <div className="flex h-full flex-1 items-center justify-center p-8">
    <div className={EMPTY_STATE_CARD_CLASS}>
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <FolderOpenIcon className="h-6 w-6" />
      </div>
      <p className="text-base font-medium text-gray-900">No files in this version</p>
      <p className="mt-2 text-sm leading-6 text-gray-500">
        This snapshot does not include any files yet.
      </p>
    </div>
  </div>
);

export const SkillCollectionViewerEmptySelectFile = () => (
  <div className="flex h-full flex-1 items-center justify-center p-8">
    <div className={EMPTY_STATE_CARD_CLASS}>
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <FileTextIcon className="h-6 w-6" />
      </div>
      <p className="text-base font-medium text-gray-900">Select a file to preview it</p>
      <p className="mt-2 text-sm leading-6 text-gray-500">
        Choose any file from the sidebar to inspect the contents of this saved version.
      </p>
    </div>
  </div>
);
